import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import EntityCommentsChat from "@/common/components/Entity/Chat/View/EntityCommentsChat";
import { EntityType, TenantRequestDto } from "@/core/api/generated/v1";

interface Props {
  tenantRequest: TenantRequestDto;
}

export default function CommentsTabContent({ tenantRequest }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <EntityCommentsChat
          entityType={EntityType.TenantRequest}
          entityId={tenantRequest.id!}
          entity={tenantRequest}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
